const config = {
  apiUrl: process.env.REACT_APP_API_URL,
  liveRatesUrl: process.env.REACT_APP_RECOMMENDATION_API_URL,
  materialApiUrl: process.env.REACT_APP_API_URL,
  supplierDataUrl: process.env.REACT_APP_API_URL,
  newsDataUrl : process.env.REACT_APP_API_URL,
};

module.exports = config;
